(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['../ApiClient', '../model/ErrorResponse500', '../model/Error', '../model/MakeActive', '../model/NavigationItems', '../model/NavigationsMeta', '../model/NavigationSetting', '../model/ThemeSettings', '../model/GetUpdates', '../model/WordPressSettings', '../model/Login', '../model/SessionData', '../model/ErrorResponse400', '../model/Logout', '../model/ResetPassword', '../model/NavigationMeta', '../model/SetUpdates'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ErrorResponse500'), require('../model/Error'), require('../model/MakeActive'), require('../model/NavigationItems'), require('../model/NavigationsMeta'), require('../model/NavigationSetting'), require('../model/ThemeSettings'), require('../model/GetUpdates'), require('../model/WordPressSettings'), require('../model/Login'), require('../model/SessionData'), require('../model/ErrorResponse400'), require('../model/Logout'), require('../model/ResetPassword'), require('../model/NavigationMeta'), require('../model/SetUpdates'));
  } else {
    // Browser globals (root is window)
    if (!root.Swagger) {
      root.Swagger = {};
    }
    root.Swagger.SettingsApi = factory(root.Swagger.ApiClient, root.Swagger.ErrorResponse500, root.Swagger.Error, root.Swagger.MakeActive, root.Swagger.NavigationItems, root.Swagger.NavigationsMeta, root.Swagger.NavigationSetting, root.Swagger.ThemeSettings, root.Swagger.GetUpdates, root.Swagger.WordPressSettings, root.Swagger.Login, root.Swagger.SessionData, root.Swagger.ErrorResponse400, root.Swagger.Logout, root.Swagger.ResetPassword, root.Swagger.NavigationMeta, root.Swagger.SetUpdates);
  }
}(this, function(ApiClient, ErrorResponse500, Error, MakeActive, NavigationItems, NavigationsMeta, NavigationSetting, ThemeSettings, GetUpdates, WordPressSettings, Login, SessionData, ErrorResponse400, Logout, ResetPassword, NavigationMeta, SetUpdates) {
  'use strict';

  /**
   * Settings service.
   * @module api/SettingsApi
   * @version 1.0.0
   */

  /**
   * Constructs a new SettingsApi. 
   * @alias module:api/SettingsApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use, default to {@link module:ApiClient#instance}
   * if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the activateTheme operation.
     * @callback module:api/SettingsApi~activateThemeCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * set given theme as active theme.
     * 
     * @param {module:model/MakeActive} body request data used to set active theme.
     * @param {String} sessionkey host sessionkey.
     * @param {module:api/SettingsApi~activateThemeCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.activateTheme = function(body, sessionkey, callback) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling activateTheme";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling activateTheme";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/active/', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the activeTheme operation.
     * @callback module:api/SettingsApi~activeThemeCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get active theme name
     * 
     * @param {String} sessionkey host sessionkey.
     * @param {module:api/SettingsApi~activeThemeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {'String'}
     */
    this.activeTheme = function(sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling activeTheme";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['text/plain'];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/active/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getNavigationData operation.
     * @callback module:api/SettingsApi~getNavigationDataCallback
     * @param {String} error Error message, if any.
     * @param {module:model/NavigationItems} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * get all the navigations
     * 
     * @param {String} id host sessionkey.
     * @param {module:api/SettingsApi~getNavigationDataCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/NavigationItems}
     */
    this.getNavigationData = function(id, callback) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling getNavigationData";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['text/plain'];
      var accepts = ['application/json'];
      var returnType = NavigationItems;

      return this.apiClient.callApi(
        '/menus/{id}/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getNavigations operation.
     * @callback module:api/SettingsApi~getNavigationsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/NavigationsMeta} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * get all the navigations
     * 
     * @param {String} sessionkey host sessionkey.
     * @param {module:api/SettingsApi~getNavigationsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/NavigationsMeta}
     */
    this.getNavigations = function(sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling getNavigations";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['text/plain'];
      var accepts = ['application/json'];
      var returnType = NavigationsMeta;

      return this.apiClient.callApi(
        '/menus/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getNavigationsSetting operation.
     * @callback module:api/SettingsApi~getNavigationsSettingCallback
     * @param {String} error Error message, if any.
     * @param {module:model/NavigationSetting} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get value of navigations selected.
     * 
     * @param {String} sessionkey host sessionkey.
     * @param {module:api/SettingsApi~getNavigationsSettingCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/NavigationSetting}
     */
    this.getNavigationsSetting = function(sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling getNavigationsSetting";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['text/plain'];
      var accepts = ['application/json'];
      var returnType = NavigationSetting;

      return this.apiClient.callApi(
        '/settings/navigations/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getThemeSettings operation.
     * @callback module:api/SettingsApi~getThemeSettingsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ThemeSettings} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get value of theme settings selected.
     * 
     * @param {String} sessionkey host sessionkey.
     * @param {module:api/SettingsApi~getThemeSettingsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/ThemeSettings}
     */
    this.getThemeSettings = function(sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling getThemeSettings";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['text/plain'];
      var accepts = ['application/json'];
      var returnType = ThemeSettings;

      return this.apiClient.callApi(
        '/settings/theme/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getUpdates operation.
     * @callback module:api/SettingsApi~getUpdatesCallback
     * @param {String} error Error message, if any.
     * @param {module:model/GetUpdates} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the type of permissions your installation will allow. Whether updates to the hub will be done automatically or manually.
     * 
     * @param {String} sessionkey host sessionkey.
     * @param {module:api/SettingsApi~getUpdatesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/GetUpdates}
     */
    this.getUpdates = function(sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling getUpdates";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['text/plain'];
      var accepts = ['application/json'];
      var returnType = GetUpdates;

      return this.apiClient.callApi(
        '/settings/updates/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getWordPressSettings operation.
     * @callback module:api/SettingsApi~getWordPressSettingsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WordPressSettings} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get value of wordpress settings selected.
     * 
     * @param {String} sessionkey host sessionkey.
     * @param {module:api/SettingsApi~getWordPressSettingsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/WordPressSettings}
     */
    this.getWordPressSettings = function(sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling getWordPressSettings";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['text/plain'];
      var accepts = ['application/json'];
      var returnType = WordPressSettings;

      return this.apiClient.callApi(
        '/settings/wordpress/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the login operation.
     * @callback module:api/SettingsApi~loginCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SessionData} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Login into HUB user account by passing user_name and password.
     * 
     * @param {module:model/Login} body The request data used to login.
     * @param {String} sessionkey host sessionkey.
     * @param {module:api/SettingsApi~loginCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/SessionData}
     */
    this.login = function(body, sessionkey, callback) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling login";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling login";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SessionData;

      return this.apiClient.callApi(
        '/login/', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the logout operation.
     * @callback module:api/SettingsApi~logoutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Log out HUB user account session from host.
     * @param {module:model/Logout} body The request data used to logout.
     * @param {String} sessionkey host sessionkey.
     * @param {module:api/SettingsApi~logoutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.logout = function(body, sessionkey, callback) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling logout";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling logout";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/logout/', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the resetPassword operation.
     * @callback module:api/SettingsApi~resetPasswordCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Reset password of HUB user account.
     * @param {module:model/ResetPassword} body The request data used to reset user account password.
     * @param {String} sessionkey host sessionkey.
     * @param {module:api/SettingsApi~resetPasswordCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.resetPassword = function(body, sessionkey, callback) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling resetPassword";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling resetPassword";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/reset/', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the setNavigations operation.
     * @callback module:api/SettingsApi~setNavigationsCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * set navigations in settings.
     * 
     * @param {String} sessionkey host sessionkey.
     * @param {Object} opts Optional parameters
     * @param {module:model/NavigationMeta} opts.body request data used to set navigations.
     * @param {module:api/SettingsApi~setNavigationsCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.setNavigations = function(sessionkey, opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling setNavigations";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/settings/navigations/', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the setThemeSettings operation.
     * @callback module:api/SettingsApi~setThemeSettingsCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * set theme settings.
     * 
     * @param {String} sessionkey host sessionkey.
     * @param {Object} opts Optional parameters
     * @param {module:model/ThemeSettings} opts.body request data used to set theme settings.
     * @param {module:api/SettingsApi~setThemeSettingsCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.setThemeSettings = function(sessionkey, opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling setThemeSettings";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/settings/theme/', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the setUpdates operation.
     * @callback module:api/SettingsApi~setUpdatesCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Select the type of permissions your installation will allow. Whether updates to the hub will be done automatically or manually..
     * 
     * @param {module:model/SetUpdates} body request data used to set updates.
     * @param {String} sessionkey host sessionkey.
     * @param {module:api/SettingsApi~setUpdatesCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.setUpdates = function(body, sessionkey, callback) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling setUpdates";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling setUpdates";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/settings/updates/', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the setWordPressSettings operation.
     * @callback module:api/SettingsApi~setWordPressSettingsCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * set wordpress settings.
     * 
     * @param {String} sessionkey host sessionkey.
     * @param {Object} opts Optional parameters
     * @param {module:model/WordPressSettings} opts.body request data used to set wordpress settings.
     * @param {module:api/SettingsApi~setWordPressSettingsCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.setWordPressSettings = function(sessionkey, opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling setWordPressSettings";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/settings/wordpress/', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));



/*****************
 ** WEBPACK FOOTER
 ** ./~/swagger/src/api/SettingsApi.js
 ** module id = 276
 ** module chunks = 0
 **/